import { render, staticRenderFns } from "./GraphTopDestinations.vue?vue&type=template&id=4279346c&"
import script from "./GraphTopDestinations.vue?vue&type=script&lang=js&"
export * from "./GraphTopDestinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports